import React from "react";
import { Props } from "react-apexcharts";
import CustomModal from "../../../ui/CustomModal";
import { Button } from "antd";

export default function DeleteConfirmModal({
  open,
  handleClose,
  handleDelete,
  loading,
}: Props) {
  return (
    <CustomModal
      disabled={false}
      open={open?.open}
      title="Delete Confirmation"
      handleClose={handleClose}
      width={472}
    >
      <h3 className="text-body text-base font-semibold font-roboto leading-loose text-start mb-4">
        Are you sure you want delete this item?
      </h3>

      <div className="flex gap-x-[12px]">
        <Button
          className="cancel-btn"
          type="text"
          size="large"
          onClick={() => handleClose()}
        >
          Cancel
        </Button>

        <Button
          className="primary_btn"
          type="primary"
          size="large"
          onClick={handleDelete}
          loading={loading}
        >
          Delete
        </Button>
      </div>
    </CustomModal>
  );
}
